/**
 * @description 入口文件
 */
// import { objectToString } from '@vue/shared';
import { wxPromisify } from './promisify';
import * as wxBridge from './bridge';
const wxAPI = wx;
export { wxBridge, wxPromisify, wxAPI as wx };
export * from './utils';
//# sourceMappingURL=index.js.map